<template>
	<div class="back">
		<div class="top">
			<div class="logo">
				<img src="~@/assets/image/housekeeper.png" />
				<span class="font">安联云管家</span>
			</div>
			<!-- <div class="top_info">
        <span style="margin-right: 10px">{{ city }}</span>
        <img :src="img[wea]" style="width: 20px; height: 20px; margin-right: 10px" />
        <span style="margin-right: 20px">{{ tem }}</span>
        <span style="margin-right: 20px">{{ time }}</span>
        <span style="margin-right: 20px" class="hover">设置</span>
        <a-button type="primary" @click="show_login"> 登录 </a-button>
      </div> -->
		</div>
		<div class="center">
			<div class="scroll">
				<div class="item" v-for="(item, index) in list" :key="index" @click="rouPath(index)">
					<img :src="item.logo" alt="" />
					<div class="company">
						<div class="c_name">{{ item.name }}</div>
						<div class="c_desp">{{ item.desp }}</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="other" v-if="is_login">
      <div class="other_center">
        <div class="other_top">
          <div class="after">账号登录</div>
          <a-icon type="close" class="close_login"  @click="is_login=false" />
        </div>
        <input class="other_input" type="text" placeholder="用户名">
        <input class="other_input" type="password" placeholder="密码">
        <div class='min_txt'>忘记密码?</div>
        <button class="login_btn">登录</button>
      </div>
    </div> -->
	</div>
</template>
<script>
	import {
		tianqiapi
	} from '@/api/assetmenag'
	export default {
		data() {
			return {
				is_login: false,
				img: {
					lei: require('../../../public/icons/lei.svg'),
					yun: require('../../../public/icons/yun.svg'),
					xue: require('../../../public/icons/xue.svg'),
					shachen: require('../../../public/icons/shachen.svg'),
					wu: require('../../../public/icons/wu.svg'),
					bingbao: require('../../../public/icons/bingbao.svg'),
					yu: require('../../../public/icons/yu.svg'),
					yin: require('../../../public/icons/yin.svg'),
					qing: require('../../../public/icons/qing.svg'),
				},
				list: [{
						name: '云管家',
						desp: '安联云管家后台',
						logo: require('../../../public/images/housekeeper2.png'),
					},
					{
						name: '检测信息化平台',
						desp: '安联检测业务后台',
						logo: require('../../../public/images/testing.png'),
					},
					{
						name: '贴身管家',
						desp: '优维验厂服务管理后台',
						logo: require('../../../public/images/uv.png'),
					},
					{
						name: '考勤智慧平台',
						desp: '优维考勤管理后台',
						logo: require('../../../public/images/uv.png'),
					},
					{
						name: '云盘',
						desp: '安联人自己的网盘',
						logo: require('../../../public/images/Cloud.png'),
					},
					{
						// name: '资产管理',
						// desp: '安联资产管理平台',
						name: '安联检评',
						desp: '检评业务信息化系统',
						logo: require('../../../public/images/review.png'),
					},
					{
						name: '安联评价',
						desp: '评价业务信息化系统',
						logo: require('../../../public/images/evaluate.png'),
					},
					{
						name: '安联环境',
						desp: '环境公卫业务信息化系统',
						logo: require('../../../public/images/environment.png'),
					},
					{
						name: 'LIMS',
						desp: '实验室信息化管理系统',
						logo: require('../../../public/images/laboratory.png'),
					},
					{
						name: '企业邮箱',
						desp: '腾讯企业邮箱',
						logo: require('../../../public/images/youxiang.png'),
					},
					{
						name: '更多',
						desp: '规划中',
						logo: require('../../../public/images/logo15.png'),
					},
				],
				city: '',
				wea: '',
				tem: '',
				time: '',
			}
		},
		created() {
			tianqiapi({
				appid: 25643864,
				appsecret: '9IAMKZnp ',
			}).then((res) => {
				this.city = res.city
				this.wea = res.data[0].wea_img
				this.tem = res.data[0].tem
				this.time = res.update_time
				console.log(res)
			})
		},
		methods: {
			rouPath(index) {
				if (index == 0) {
					this.$router.push({
						name: 'login',
					})
				} else if (index == 1) {
					// window.open('http://47.111.249.220:81/#/login')
					window.open('http://123.6.102.97:81/')
				} else if (index == 2) {
					// window.open('https://xcx.uv8000.org/login')
					window.open('https://xcx.anliantest.com/')

				} else if (index == 3) {

					// window.open('http://60.190.21.178:81/')
					window.open('http://123.6.102.97:88')

				} else if (index == 4) {
					// window.open('http://60.190.21.178:99/')
					window.open('http://123.6.102.97:99')

				} else if (index == 5) {
					// window.open('http://47.111.249.220:84/') 
					// window.open('http://39.185.236.201:83') 
					window.open('http://123.6.102.97:83/')
				} else if (index == 6) {
					// window.open('http://47.111.249.220:82/')
					// window.open('http://39.185.236.201:86')
					window.open('http://123.6.102.97:86/')

				} else if (index == 7) {
					// window.open('http://47.114.182.181:60/#/')
					window.open('http://123.6.102.97:60/')

				} else if (index == 8) {
					// window.open('http://47.111.249.220:85/')
					// window.open('http://39.185.236.201:85')
					window.open('http://123.6.102.97:85/')
				} else if (index == 9) {
					window.open('https://work.weixin.qq.com/mail/')
				}
			},
			show_unit() {},
			show_login() {
				this.is_login = true;
			}
		},
	}
</script>
<style lang="less" scoped>
	.back {
		width: 100%;
		height: 100vh;
		background-image: url(~@/assets/image/back.png);
		background-size: 100% 100%;

		.top {
			width: 100%;
			height: 100px;
			float: left;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			box-sizing: border-box;

			.logo {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				margin-left: 45px;

				img {
					width: 90px;
					float: left;
				}

				span {
					float: left;
					font-size: 18px;
					margin-left: 10px;
					font-weight: 600;
					color: #555;
				}
			}
		}

		.center {
			width: 100%;
			height: calc(100% - 100px);
			float: left;
			display: flex;
			justify-content: center;
			align-items: center;

			.scroll {
				width: 70%;
				height: 85%;
				float: left;
				padding: 10px;
				overflow-y: scroll;

				&::-webkit-scrollbar {
					display: none;
				}

				.item {
					width: calc((100% / 3) - 40px);
					opacity: 0.8;
					float: left;
					margin-right: 60px;
					margin-bottom: 50px;
					padding: 30px 25px;
					box-sizing: border-box;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					background: #fff;
					cursor: pointer;
					border-radius: 10px;
					box-shadow: 0px 0px 15px rgb(180, 180, 180);
					height: 145px;

					&:nth-child(3n) {
						margin: 0;
					}

					img {
						width: 16%;
						float: left;
					}

					.company {
						float: left;
						color: #fff;
						margin-left: 30px;

						.c_name {
							font-size: 18px;
							color: #555;
							font-weight: 600;
						}

						.c_desp {
							font-size: 16px;
							margin-top: 10px;
							color: #909090d2;
							font-weight: bold;
						}
					}
				}

				.item:hover {
					-webkit-box-shadow: 0 0 5px rgba(0, 113, 241, 1);
				}
			}
		}
	}

	.hover {
		cursor: pointer;
	}

	.other {
		width: 100%;
		height: 100vh;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 4;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		justify-content: center;
		align-items: center;

		.other_center {
			width: 400px;
			background: #fff;
			padding: 35px 25px;
			border-radius: 10px;
			overflow: hidden;

			.other_top {
				width: 100%;
				float: left;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.after {
					padding-bottom: 5px;
					border-bottom: 4px solid #4e6ef2;
				}

				.close_login {
					font-size: 18px;
					cursor: pointer;
					transition: 0.3s;

					&:hover {
						color: red;
					}
				}
			}

			.other_input {
				width: 100%;
				float: left;
				border-radius: 5px;
				border: 1px solid #777;
				margin-top: 20px;
				height: 45px;
				padding: 0 5px;
				box-sizing: border-box;
				outline: none;
			}

			.min_txt {
				width: 100%;
				float: left;
				font-size: 13px;
				color: #4e6ef2;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				margin-top: 15px;
				cursor: pointer;
			}

			.login_btn {
				width: 100%;
				height: 45px;
				float: left;
				margin-top: 20px;
				color: #fff;
				background: #4e6ef2;
				border-radius: 10px;
				cursor: pointer;
				outline: none;
			}
		}
	}
</style>
